import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, TextInput } from '../../types'
import { CmsConverterService, defaultTextInput } from '../../../services/cms-converter/cms-converter.service'
import { v4 as uuidv4 } from 'uuid'

@Injectable({ providedIn: 'root' })
export class MacsMapItemConverter extends CmsConverterService<MacsMapItemData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      top: formData.st_top?.value ?? 0,
      left: formData.st_left?.value ?? 0,
      name: formData.st_name ?? defaultTextInput,
      panelHeadline: formData.st_panel_headline ?? defaultTextInput,
      address: formData.st_address ?? defaultTextInput,
      email: formData.st_email ?? defaultTextInput,
      align: formData.st_align?.value?.identifier ?? 'right',
      uuid: uuidv4(),
      selected: false,
    }
  }
}

export const MACS_MAP_ITEM_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, MacsMapItemData>>('MacsMapItemConverter')

export interface MacsMapItemData extends ConvertedComponentData {
  panelHeadline: TextInput;
  name: TextInput;
  address: TextInput;
  email: TextInput;
  top: number;
  left: number;
  selected: boolean;
  align: string;
  uuid: string;
}
